import { Container, Row, Col, Button } from "react-bootstrap";
import ContentImage from "../component/ContentImage";
import { PersonArmsUp, Bullseye, Eye } from 'react-bootstrap-icons';
import { useEffect } from "react";
import Reveal from "../component/Reveal";
import HeroBanner from "../component/HeroBanner";
import ImageKit from "../component/ImageKit";

const AboutUs = () => {
  useEffect(()=>{
    document.title = "JCI Lucena - About Us"
  }, [])

  return (
    <div>
      <div className="hero-banner-div">
        {/* <div className="about-us-hero-banner-text-div">
          <Reveal delay={0.2}>
            <div>
              <b className="about-us-jci-lucena-text">JCI Lucena</b> <p className="about-us-text">About Us</p>
            </div>
          </Reveal>
        </div> */}
        <HeroBanner
          className="about-us-hero-banner"
          src={'https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-1200,f-auto,q-80 1920w'}
          srcSet={`
            https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-400,fo-top,q-60 400w,
            https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-800,fo-top,q-60 800w,
            https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-1200,fo-top,q-60 1200w,
            https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-1920,fo-center,q-70 1920w,
            https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-2560,fo-top,q-80 2560w,
            https://ik.imagekit.io/wwg4nuz3a/about-us-hero-banner.jpg?tr=w-3840,fo-top,q-80 3840w
          `}
          // src={'post-placeholder.png'}
          sizes="100vw"
        />
      </div>
      <Container>
        <Row  className="about-us-row">
          <Col>
            <Reveal delay={0.2}>
              <div className="left-about-div">
                <ContentImage
                  src="placeholder.png"
                />
                <div className="left-about-header-paragraph-div">
                  <h1><b>History</b></h1>
                  <p>Founded in 1948, JCI Lucena has grown alongside Lucena City for 77 years, producing leaders who leave a mark in business, government, and civil society.</p>
                  <p>Every generation of members continues the legacy of service, leadership, and bold action, ensuring that JCI Lucena remains a beacon for young leaders ready to lead, rise, and rock on.</p>
                  {/* <h3>Join JCI Lucena to:</h3>
                  <ul>
                    <li>Develop leadership skills that make a real impact</li>
                    <li>Lead community projects that matter</li>
                    <li>Connect with like-minded, driven leaders</li>
                    <li>Step up. Rise above. Rock on with us.</li>
                  </ul>
                  <Button variant="primary" className="about-us-join-us-button">Learn More</Button> */}
                </div>
              </div>
            </Reveal>
            {/* <div className="about-us-join-us-section">
              <h1><b>Join Us</b></h1>
              <h3>Are you 18 to 40 years old and ready to lead, rise, and rock on?</h3>
              <h3>Join JCI Lucena to:</h3>
              <ul>
                <li>Develop leadership skills that make a real impact</li>
                <li>Lead community projects that matter</li>
                <li>Connect with like-minded, driven leaders</li>
              </ul>
              <p>Step up. Rise above. Rock on with us.</p>
              <Button variant="primary">Become a member</Button>
            </div> */}
            <Reveal delay={0.2}>
              <div className="right-about-div">
                <img
                  src="https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-1200,f-auto,q-80 1200w"
                  srcSet="
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-400,fo-auto,q-70 400w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-800,fo-auto,q-70 800w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-1200,fo-auto,q-70 1200w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-1920,fo-auto,q-80 1920w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-2560,fo-auto,q-80 2560w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-who-we-are1.jpg?tr=w-3840,fo-auto,q-80 3840w
                  "
                  sizes="
                    (max-width: 640px) 390px,
                    (max-width: 1024px) 50vw, 30vw
                  "
                />
                <div className="right-about-header-paragraph-div">
                  <h1><b>Who We Are</b></h1>
                  <p>
                    <b>JCI Lucena</b> is a community of young active citizens aged 18 to 40, committed to making Lucena City a better place. 
                    Since 1948, we have spent 77 years building leaders who step up, rise, and rock on—turning ideas into action and service into meaningful impact.
                  </p>
                  <p>
                    As part of Junior Chamber International (JCI), we empower young professionals to lead with purpose and rise to challenges with bold action.
                    Our mission is simple: create leaders who inspire change and communities that thrive.
                  </p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="left-about-div">
                <img
                  src="https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-1200,f-auto,q-80 1200w"
                  srcSet="
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-400,fo-auto,q-70 400w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-800,fo-auto,q-70 800w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-1200,fo-auto,q-70 1200w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-1920,fo-auto,q-80 1920w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-2560,fo-auto,q-80 2560w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-what-we-do.jpg?tr=w-3840,fo-auto,q-80 3840w
                  "
                  sizes="
                    (max-width: 640px) 390px,
                    (max-width: 1024px) 50vw, 30vw
                  "
                />
                <div className="left-about-header-paragraph-div">
                  {/* <h1><b>What Do We Stand For?</b></h1> */}
                  <h1><b>What We Do</b></h1>
                  <p> We empower young leaders to take action through: </p>
                  <ul className="about-us-undordered-list">
                    <li><b>Leadership Development</b> – trainings, workshops, and conventions to sharpen skills and confidence</li>
                    <li><b>Community Projects</b> – initiatives in education, health, social development, and culture</li>
                    <li><b>Active Citizenship</b> – promoting civic responsibility and ethical leadership</li>
                    <li><b>Partnerships & Collaboration</b> – working with government, NGOs, and private sectors for bigger impact</li>
                  </ul>
                  <p>At JCI Lucena, every project is a stage to lead, every challenge a chance to rise, every success a reason to rock on.</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="right-about-div">
                <img
                  src="https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-1200,f-auto,q-80 1200w"
                  srcSet="
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-400,fo-auto,q-70 400w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-800,fo-auto,q-70 800w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-1200,fo-auto,q-70 1200w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-1920,fo-auto,q-80 1920w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-2560,fo-auto,q-80 2560w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-core-values?tr=w-3840,fo-auto,q-80 3840w
                  "
                  sizes="
                    (max-width: 640px) 390px,
                    (max-width: 1024px) 50vw, 30vw
                  "
                />
                <div className="right-about-header-paragraph-div">
                  {/* <h1><b>What Do We Aim For?</b></h1> */}
                  <h1><b>Core Values</b></h1>
                  <p>
                    Our journey is guided by the core values of JCI:
                  </p>
                  <ul className="about-us-undordered-list">
                    <li><b>Faith in Humanity</b> – Believing in people’s potential to create change</li>
                    <li><b>Service to the Community</b> – Leadership finds its fullest expression in service</li>
                    <li><b>Active Citizenship</b> – Taking responsibility to improve communities and the nation</li>
                    <li><b>Respect for Human Dignity</b> – Upholding equality, integrity, and respect</li>
                    <li><b>Economic Justice</b> – Supporting fair and sustainable development for all</li>
                  </ul>
                  <p>These values keep us grounded, inspired, and unstoppable.</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="left-about-div">
                <img
                  src="https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-1200,f-auto,q-80 1200w"
                  srcSet="
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-400,fo-auto,q-70 400w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-800,fo-auto,q-70 800w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-1200,fo-auto,q-70 1200w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-1920,fo-auto,q-80 1920w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-2560,fo-auto,q-80 2560w,
                    https://ik.imagekit.io/wwg4nuz3a/about-us/about-us-our-creed.jpg?tr=w-3840,fo-auto,q-80 3840w
                  "
                  sizes="
                    (max-width: 640px) 390px,
                    (max-width: 1024px) 50vw, 30vw
                  "
                />
                <div className="left-about-header-paragraph-div">
                  <h1><b>Creed</b></h1>
                  <p className="our-creed-text">We Believe:</p>
                  <p className="our-creed-text">That faith in God gives meaning and purpose to human life,</p>
                  <p className="our-creed-text">That the brotherhood of man transcends the sovereignity of nations.</p>
                  <p className="our-creed-text">That economic justice can be won by freeman through free enterprise.</p>
                  <p className="our-creed-text">That government should be of laws rather than of men.</p>
                  <p className="our-creed-text">That earth's greatest treasure lies in human personality.</p>
                  <p className="our-creed-text">And that service to humanity is the best work of life.</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="jci-about-us-creed-mission-vision-div">
                <div className="jci-about-us-creed-mission-vision">
                  <div className="jci-about-us-creed-mission-vision-icon-paragpraph">
                    <PersonArmsUp size={50} color='white'/>
                    <h3>JCI Prayer</h3>
                  </div>
                  <p>
                    We reaffirm our conviction that faith in God gives meaning and purpose to human life, may the Lord guide us in all our undertakings.
                  </p>
                </div>
                <div className="middle-jci-about-us-creed-mission-vision">
                  <div className="middle-jci-about-us-creed-mission-vision-icon-paragpraph">
                    <Bullseye size={50} color='black'/>
                    <h3>JCI Mission</h3>
                  </div>
                  <p>
                    To provide leadership development opportunities that empower young people to create positive change.
                  </p>
                </div>
                <div className="jci-about-us-creed-mission-vision">
                  <div className="jci-about-us-creed-mission-vision-icon-paragpraph">
                    <Eye size={50} color='white'/>
                    <h3>JCI Vision</h3>
                  </div>
                  <p>
                    To be the foremost global network of young leaders.
                  </p>
                </div>
              </div>
            </Reveal>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AboutUs;